import util from 'library/util';
import moment from 'moment';
import LOOKUP from 'constants/lookup';

export default class DefaultValidator {
    constructor() {
    }

    validatePatient(componentName, model, formError, isHighTide = false, isInspired = false) {
        const validators = [
            [`${componentName}FirstName`, model => (model.FirstName && model.FirstName !== undefined && model.FirstName !== null && model.FirstName !== ""), "First Name"],
            [`${componentName}LastName`, model => (model.LastName && model.LastName !== null && model.LastName !== ""), 'Last Name'],
        ];
    
        // Conditionally add Email and Phone validation if isHighTide is true
        if (isHighTide) {
            validators.push(
                [`${componentName}Email`, model => (model.Email && model.Email !== null && model.Email !== ""), 'Email'],
                [`${componentName}Phone`, model => (model.Phone && model.Phone !== null && model.Phone !== ""), 'Phone Number'],
                [`${componentName}PostalCode`, model => (model.PostalCode && model.PostalCode !== null && model.PostalCode !== ""), 'Postal Code']
            );
        }

        if (isInspired) {
            validators.push(
                [`${componentName}Phone`, model => (model.Phone && model.Phone !== null && model.Phone !== ""), 'Phone Number']
            );            
        }
    
        return util.validate(validators, model, formError);
    }
    
    validatePatientBirthDate(componentName, model, formError) {
        const validators = [
            [`${componentName}Birthdate`, model => (model.DateOfBirth && model.DateOfBirth !== null && model.DateOfBirth !== "" && (new Date().getFullYear() - model.DateOfBirth.getFullYear() <= LOOKUP.patient.maxAge) && (model.DateOfBirth.getFullYear() < new Date().getFullYear())), "Birth Date"]
        ];
        return util.validate(validators, model, formError);
    }
}
